import { render, staticRenderFns } from "./TypeNameManageView.vue?vue&type=template&id=396cefd4&scoped=true&"
import script from "./TypeNameManageView.vue?vue&type=script&lang=js&"
export * from "./TypeNameManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396cefd4",
  null
  
)

export default component.exports